/* eslint-disable react/function-component-definition */
import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router'
import { AppFrame } from 'transfix-ui/components/AppFrame'
import { useChatWidgetContext } from 'utils/context/ChatWidgetContext'
import {
  EldIntegrationStepImportTrucks,
  EldIntegrationStepConnect,
  ELD_ROUTES,
} from 'apps/fleet-planner/components/eld-integration'

/**
 * Handles multi-step process around ELD Integration for a carrier
 */
export const EldIntegrationWizardPage = () => {
  const { boot, shutdown } = useChatWidgetContext()

  /**
   * Hide the chat widget for the wizard page / steps
   */
  useEffect(() => {
    shutdown()

    return () => {
      boot()
    }
  })

  return (
    <AppFrame>
      <Switch>
        {/**
         * Connect carrier
         */}
        <Route exact path={[ELD_ROUTES.connect.location]} component={EldIntegrationStepConnect} />
        {/**
         * Import trucks
         */}
        <Route
          exact
          path={[ELD_ROUTES.importTrucks.location]}
          component={EldIntegrationStepImportTrucks}
        />
      </Switch>
    </AppFrame>
  )
}
